import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-popup-loading',
  templateUrl: './popup-loading.component.html',
  styleUrls: ['./popup-loading.component.scss']
})
export class PopupLoadingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
